// App Imports
import { IMAGE_SOURCE_PATH } from '../../../setup/config/env'
import params from '../../../setup/config/params'
import List from '../List'
import CreateOrUpdate from '../CreateOrUpdate'
import BulkCreate from '../BulkCreate';
import { defaultImage } from '../../common/Sidebar';

// Image

export function getImageSource(image = defaultImage) {
  const targetImage = image || defaultImage || "default.jpg";
  if (typeof targetImage === 'string' && (targetImage.startsWith('http://') || targetImage.startsWith('https://') || targetImage.startsWith('data:') || targetImage.startsWith('blob:'))) {
    return targetImage;
  }
  const cleanImage = typeof targetImage === 'string' ? targetImage.replace(/^\/+/, '') : targetImage;
  const basePath = IMAGE_SOURCE_PATH ? (IMAGE_SOURCE_PATH.endsWith('/') ? IMAGE_SOURCE_PATH : `${IMAGE_SOURCE_PATH}/`) : '/';
  return `${basePath}${cleanImage}`;
}

// Pages routes
const routes = {
  productList: {
    path: (page = ":page") => `/products/${page}`,
    activePath: "/product",
    component: List,
    auth: true,
    role: [params.user.roles.admin.key, params.user.roles.vendor.key],
    module: "store",
    subModule: "products",
    action: "canView",
  },

  productCreate: {
    path: "/product/create",
    component: CreateOrUpdate,
    auth: true,
    role: [params.user.roles.admin.key, params.user.roles.vendor.key],
    module: "store",
    subModule: "products",
    action: "canCreate",
  },
  productBulkCreate: {
    path: "/product/bulkcreate",
    component: BulkCreate,
    auth: true,
    role: [params.user.roles.admin.key, params.user.roles.vendor.key],
    module: "store",
    subModule: "products",
    action: "canCreate",
  },

  productEdit: {
    path: (productId = ":productId") => `/product/edit/${productId}`,
    component: CreateOrUpdate,
    auth: true,
    role: [params.user.roles.admin.key, params.user.roles.vendor.key],
    module: "store",
    subModule: "products",
    action: "canView",
  },
};

export default routes;